// translation.module.ts
import { ModuleWithProviders, NgModule } from '@angular/core';
import {
  HttpClient,
} from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

/**
 * Feature modules import `TranslationModule` (pipe/directive only).
 * Only AppModule imports `TranslationModule.forRoot()`: providing TranslateService again in a
 * lazy-loaded module would give it its own instance that never sees the language picked in the header.
 */
@NgModule({
  exports: [TranslateModule],
})
export class TranslationModule {
  static forRoot(): ModuleWithProviders<TranslationModule> {
    return {
      ngModule: TranslationModule,
      providers: TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }).providers,
    };
  }
}
